import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden px-4 py-20" data-id="element-59">
      {/* Background decorative elements */}
      <div className="absolute inset-0 z-0 opacity-20" data-id="element-60">
        <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-blue-500 rounded-full shadow-[0_0_15px_5px_rgba(59,130,246,0.5)]" data-id="element-61"></div>
        <div className="absolute top-1/3 right-1/4 w-1.5 h-1.5 bg-blue-400 rounded-full shadow-[0_0_10px_3px_rgba(96,165,250,0.5)]" data-id="element-62"></div>
        <div className="absolute bottom-1/4 left-1/3 w-2.5 h-2.5 bg-blue-600 rounded-full shadow-[0_0_20px_5px_rgba(37,99,235,0.5)]" data-id="element-63"></div>
        <div className="absolute top-1/2 right-1/3 w-1 h-1 bg-blue-300 rounded-full shadow-[0_0_8px_2px_rgba(147,197,253,0.5)]" data-id="element-64"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-65">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-66">
          <h1 className="text-5xl md:text-7xl font-black mb-4 leading-tight tracking-tight" data-id="element-67">
            Facebook Ads <span className="text-blue-500" data-id="element-68">Andrómeda</span>
          </h1>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-300 mb-8" data-id="element-69">
            10 Secretos para NO Botar Tu Dinero
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-gray-400 mb-10 max-w-3xl mx-auto space-y-4" data-id="element-70">
          <p data-id="element-71">
            Si estás corriendo anuncios en Facebook/Instagram y sientes que
            pagas, pagas, pagas… pero los resultados no son consistentes, hay
            una razón muy simple:
          </p>
          <p data-id="element-72">
            No es que "Meta no funciona". No es que "tu producto no sirve". Y
            muchas veces ni siquiera es tu anuncio.
          </p>
          <p className="font-semibold text-white" data-id="element-73">
            Es que estás interrumpiendo el aprendizaje (sin darte cuenta) y
            obligando a Andrómeda a trabajar con ruido en vez de datos.
          </p>
          <p data-id="element-74">Y cuando eso pasa, el algoritmo no optimiza… adivina.</p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} data-id="element-75">
          <a href="https://pay.hotmart.com/J105202862M" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-amber-500 rounded-lg hover:bg-amber-400 transition-all duration-300 shadow-[0_0_20px_rgba(245,158,11,0.4)] hover:shadow-[0_0_30px_rgba(245,158,11,0.6)]" data-id="element-76">
            SÍ, QUIERO DEJAR DE BOTAR DINERO
            <ArrowRight className="ml-2 w-5 h-5" data-id="element-77" />
          </a>
        </motion.div>
      </div>
    </section>;
}